import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root',
})
export class ReservaDataService {
  private reservaData: any = {};

  setData(key: string, data: any): void {
    this.reservaData[key] = data;
  }

  getData(key: string): any {
    return this.reservaData[key] || null;
  }

  getConsolidatedData(): any {
    return {
      ...this.reservaData['personaSeleccionada'],
      ...this.reservaData['step2'],
      id_estado: 2,
      // Puedes añadir otros pasos aquí si hay más datos
    };
  }
}


